import { Building2 } from 'lucide-react';

export interface ReportHeaderProps {
  brand: string;
  monthRange?: string;
  date: Date;
}

// Lock timezone về Việt Nam — không phụ thuộc browser locale của user
const FORMATTER = new Intl.DateTimeFormat('vi-VN', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Asia/Ho_Chi_Minh',
});

export function ReportHeader({ brand, monthRange, date }: ReportHeaderProps) {
  return (
    <header className="flex flex-col gap-3 border-b-2 border-primary pb-4 print-no-break sm:flex-row sm:items-end sm:justify-between sm:gap-6">
      <div className="flex items-center gap-3 sm:gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary sm:h-12 sm:w-12">
          <Building2 className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={1.5} />
        </div>
        <div className="min-w-0">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground sm:text-xs">
            GearVN × {brand}
          </div>
          <h1 className="mt-0.5 text-lg font-bold tracking-tight sm:mt-1 sm:text-2xl">
            Báo cáo Hiệu suất — {brand}
          </h1>
          <p className="mt-0.5 text-[11px] text-muted-foreground sm:mt-1 sm:text-xs">
            Monitor Category{monthRange ? ` · ${monthRange}` : ''} · GearVN
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between gap-2 text-[11px] sm:block sm:text-right sm:text-xs">
        <div className="whitespace-nowrap text-foreground">Ngày xuất: {FORMATTER.format(date)}</div>
        <div className="whitespace-nowrap font-semibold uppercase tracking-wider text-destructive sm:mt-0.5">
          <span className="sm:hidden">Confidential</span>
          <span className="hidden sm:inline">Confidential — Internal use</span>
        </div>
      </div>
    </header>
  );
}
